import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DialerSettingsModal from './dialer-settings-modal';
import { IProps } from './types';
import { updateAdminSettingsRequest } from '../../../../../../../settings/components/admin-settings/extra-actions';
import { RootState } from '../../../../../../../../store/root-reducer';
import { AdminSettings } from '../../../../../../../settings/types/admin-settings';
import { ShAccountSettingsCode } from '../../../../../../../settings/enums/admin-settings';
import toaster, { Theme } from '../../../../../../../../shared/toaster';
import { executeOnRequestStatus } from '../../../../../../../../shared/utils/execute-on-request-status';
import { getAdminSettingsRequest, resetUpdateAdminSettings } from '../../../../../../../settings/components/admin-settings/admin-settings-slice';

const DialerSettingsModalContainer: React.FC<IProps> = (props) => {
    const dispatch = useDispatch();
    const handleSubmit = (localPresence: boolean, numberRotation: boolean) => {
      const settings = [
        {
          code: ShAccountSettingsCode.DialerLocalPresenceEnabled,
          value: localPresence ? '1' : '0',
        },
        {
          code: ShAccountSettingsCode.DialerNumberRotationEnabled,
          value: numberRotation ? '1' : '0',
        },
      ];
      dispatch(updateAdminSettingsRequest({ settings }));
    };
    const updateAdminSettingsRequestStatus = useSelector((state: RootState) => state.adminSettings.updateAdminSettingsRequest.status);

    useEffect(() => {
      executeOnRequestStatus({
        status: updateAdminSettingsRequestStatus,
        onSuccess: () => {
          dispatch(getAdminSettingsRequest());
          toaster.success('Dialer settings updated successfully', { theme: Theme.New });
          dispatch(resetUpdateAdminSettings());
          props.onClose?.();
        },
        onFailed: () => {
          toaster.error('Failed to update dialer settings', { theme: Theme.New });
          dispatch(resetUpdateAdminSettings());
          props.onClose?.();
        },
      });
    }, [updateAdminSettingsRequestStatus]);
  const settings = useSelector((state: RootState) => state.adminSettings.adminSettings);
  const dialerLocalPresenceEnabled = settings?.find((setting: AdminSettings) => setting.code === ShAccountSettingsCode.DialerLocalPresenceEnabled)?.value === '1';
  const dialerNumberRotationEnabled = settings?.find((setting: AdminSettings) => setting.code === ShAccountSettingsCode.DialerNumberRotationEnabled)?.value === '1';
  return (
    <DialerSettingsModal
      {...props}
      dialerLocalPresenceEnabled={dialerLocalPresenceEnabled}
      dialerNumberRotationEnabled={dialerNumberRotationEnabled}
      onSubmit={handleSubmit}
      updateAdminSettingsRequestStatus={updateAdminSettingsRequestStatus}
    />
  );
};

export default memo(DialerSettingsModalContainer);

